module.exports = __webpack_public_path__ + "static/media/Photo 2020-04-10, 7 44 30 AM.e8397e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Photo 2020-04-10, 7 44 30 AM.jpg
// module id = 382
// module chunks = 0